const Tune = {
	init: () => {
		const queryString = window.location.search;
		const params = new URLSearchParams(queryString);

		if (params.get('source') === 'tune') {
			Tune.sendDataToApp(params);
		}
	},

	/**
	 * Send data to the codeable app to track the referral
	 * @param params
	 */
	sendDataToApp(params) {
		const payload = {
			'session_id': params.get('transaction_id') || '',
			'partner_id': params.get('partner_id') || '',
			'plan_id': params.get('offer_id') || '',
			'partner_name': params.get('id') || ''
		};

		// Specify your endpoint URL
		const endpoint = Tune.getAppEndpoint();

		// Send a POST request to the endpoint with the payload
		fetch(endpoint, {
			method: 'POST',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		})
			.then(response => response.json())
			.then(data => {
				console.log('Success:', data);
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	},

	/**
	 * Get the correct endpoint for the app
	 * @returns {string}
	 */
	getAppEndpoint() {
		if (window.location.hostname === 'www.codeable.io') {
			return 'https://api.codeable.io/referrals/visits/tune';
		} else {
			return 'https://api.staging.codeable.io/referrals/visits/tune';

		}

	}
}

export default Tune;
